import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import SOUNDS from 'sounds'

export const BUILDING_CONSTRUCTION_REQUEST = 'building_construction/REQUEST'
export const BUILDING_CONSTRUCTION_SUCCESS = 'building_construction/SUCCESS'
export const BUILDING_CONSTRUCTION_ERROR = 'building_construction/ERROR'
export const BUILDING_CONSTRUCTION_ANIMATED = 'building_construction/ANIMATED'
export const BUILDING_CONSTRUCT_CONFIRMATION_OPEN = 'building_construction/OPEN_CONFIRMATION'
export const BUILDING_CONSTRUCT_CONFIRMATION_CLOSE = 'building_construction/CLOSE_CONFIRMATION'


export function startRequest() {
    return {
        type: BUILDING_CONSTRUCTION_REQUEST,
        payload: {},
    }
}

export function constructionSuccess(data, slotId) {
    const { building, industrial_resource_balance } = data
    return {
        type: BUILDING_CONSTRUCTION_SUCCESS,
        payload: {
            building,
            slotId,
            industrialResourceBalance: industrial_resource_balance,
        },
        meta: {
            webToClient: {
                handler: 'playSound',
                params: { soundId: SOUNDS.BUILDING_CONSTRUCTION },
            },
        },
    }
}

export function constructionError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: BUILDING_CONSTRUCTION_ERROR,
        payload: errorData,
    }
}

export function constructionAnimated(buildingId) {
    return {
        type: BUILDING_CONSTRUCTION_ANIMATED,
        payload: { buildingId },
    }
}


export function openConstructConfirmation() {
    return {
        type: BUILDING_CONSTRUCT_CONFIRMATION_OPEN,
        payload: {},
    }
}

export function closeConstructConfirmation() {
    return {
        type: BUILDING_CONSTRUCT_CONFIRMATION_CLOSE,
        payload: {},
    }
}


export default function constructBuilding(slotId, buildingType) {
    return async (dispatch, getState) => {
        if (getState().buildingConstruction.submitting) {
            return Promise.resolve()
        }
        dispatch(startRequest())
        const url = `/game_api/slot_building/${slotId}`
        const data = { building_type: buildingType }
        httpRequest(url, 'POST', data).then(
            data => dispatch(constructionSuccess(data, slotId)),
            errorData => dispatch(constructionError(errorData))
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/building_construction.js